import React, { useMemo } from "react";
import { IconBrandWhatsapp, IconBrandInstagram, IconBrandMessenger } from "@tabler/icons-react";
import { useServiceCenter } from "../../contexts";
import "./ChannelFilters.css";

const CHANNEL_META = {
  whatsapp: {
    label: "WhatsApp",
    Icon: IconBrandWhatsapp,
    color: "#25D366",
  },
  instagram: {
    label: "Instagram",
    Icon: IconBrandInstagram,
    color: "#E1306C",
  },
  messenger: {
    label: "Messenger",
    Icon: IconBrandMessenger,
    color: "#0084FF",
  },
};

/**
 * Chips de filtro por canal (omnichannel). Aparece só os canais que o
 * usuário tem account ativa. Click toggla. "Todos" limpa o filtro.
 */
const ChannelFilters = () => {
  const { accounts, selectedChannels, setSelectedChannels } = useServiceCenter();

  const availableChannels = useMemo(() => {
    const set = new Set();
    (accounts || []).forEach((a) => {
      if (a.channel) set.add(a.channel);
    });
    return [...set];
  }, [accounts]);

  // Esconde se só tem 1 canal — não há o que filtrar
  if (availableChannels.length < 2) return null;

  const isAll = !selectedChannels || selectedChannels.size === 0;

  const toggleChannel = (channel) => {
    const next = new Set(selectedChannels || []);
    if (next.has(channel)) {
      next.delete(channel);
    } else {
      next.add(channel);
    }
    setSelectedChannels([...next]);
  };

  const clearAll = () => setSelectedChannels([]);

  return (
    <div className="sc-channel-filters" role="group" aria-label="Filtrar por canal">
      <button
        type="button"
        className={`sc-channel-chip${isAll ? " is-active" : ""}`}
        onClick={clearAll}
        aria-pressed={isAll}
      >
        Todos
      </button>
      {availableChannels.map((channel) => {
        const meta = CHANNEL_META[channel];
        if (!meta) return null;
        const active = selectedChannels?.has(channel);
        return (
          <button
            key={channel}
            type="button"
            className={`sc-channel-chip sc-channel-chip--${channel}${active ? " is-active" : ""}`}
            style={{ "--channel-color": meta.color }}
            onClick={() => toggleChannel(channel)}
            aria-pressed={!!active}
          >
            <meta.Icon size={14} className="sc-channel-chip__icon" />
            <span>{meta.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ChannelFilters;
